import removeMarketingCurtain from './remove-marketing-curtain';

function updateScrollPosition(megaNavUIData){
  
  const navHeight = megaNavUIData.height;
  const toggleSticky = megaNavUIData.toggleSticky;
  const productGrid = document.querySelector('.product-grid');
  const productGridOffsetTop = productGrid.offsetTop;
  const currentScrollValue = window.pageYOffset;
  const scrollTarget = productGridOffsetTop - navHeight;
  const isInScrollingArea = currentScrollValue > scrollTarget;
  if (isInScrollingArea) {
      removeMarketingCurtain();
      window.scrollTo?.(0, scrollTarget);
      if (!navHeight) {
         toggleSticky(false);
      }
      setTimeout(toggleSticky, 1);
   }
}

export default updateScrollPosition;
